import { render, staticRenderFns } from "./OrderStateHistory.vue?vue&type=template&id=22c3d106&scoped=true&"
import script from "./OrderStateHistory.vue?vue&type=script&lang=js&"
export * from "./OrderStateHistory.vue?vue&type=script&lang=js&"
import style0 from "./OrderStateHistory.vue?vue&type=style&index=0&id=22c3d106&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c3d106",
  null
  
)

export default component.exports